import React from "react";
import { Button, Result } from "antd";

type ErrorBoundaryState = { hasError: boolean };

// In addition to the errorElement of React Router, catch exceptions in the rendering phase of ordinary components.
class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Something went wrong"
          subTitle="Please refresh the page and try again."
          extra={<Button onClick={() => window.location.reload()}>Refresh</Button>}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
